module.exports = __webpack_public_path__ + "img/test_c.2c26be80.png";